<template>
  <CRow>
    <CCol>
      <template v-if="message.status">
        <CAlert maxlength="255" :color="message.status" closeButton>
          {{ message.message }}
        </CAlert>
        <h2 class="h1 mb-5" :class="`text-${message.status}`"></h2>
      </template>
      <CForm autocomplete="OFF" @submit.prevent="register">
        <h1 class="mb-5">
          {{ $t('auth.newRegister.header1.sign-up') }}
        </h1>
        <!-- <CRow :gutters="false" v-if="!external">
          <SocialLogin />
        </CRow> -->
        <CRow>
          <CCol md="6">
            <CInput
              class="mb-0"
              :label="$t('auth.newRegister.input.name')"
              type="text"
              maxlength="255"
              id="namme"
              addLabelClasses="mt-1 mb-0 required"
              :value.sync="$v.user.name.$model"
              :isValid="checkIfValid('name')"
              :invalidFeedback="assignInvalidFeedback($v.user.name)"
              aria-describedby=""
              :placeholder="$t('auth.newRegister.input.name')"
              :readonly="external"
              :autocomplete="false"
            />
          </CCol>
          <CCol md="6">
            <CRow :gutters="false">
              <CCol sm="12">
                <label for="number" class="label-custom required mt-1">
                  {{ $t('auth.newRegister.input.mobile-number') }}
                </label>
              </CCol>
              <CCol sm="12">
                <CRow sm="12" class="d-flex" :gutters="false">
                  <CCol sm="6" class="mr-1">
                    <v-select
                      class="mb-0 no-close mt-0 select-form"
                      :options="optionsCountries"
                      :class="{
                        'is-invalid':
                          ($v.user.phoneCountryIndicator.$model == '' && $v.user.phoneNumber.$dirty && $v.user.phoneNumber.$invalid) ||
                          (!$v.user.phoneNumber.$invalid && $v.user.phoneCountryIndicator.$model == ''),
                      }"
                      v-model="$v.user.phoneCountryIndicator.$model"
                      :isValid="checkIfValid('phoneCountryIndicator')"
                      id="countrySelected"
                      :placeholder="$t('general.input.placeholder.country-code')"
                    >
                      <template #selected-option="{ label, flag }">
                        <div class="d-flex align-items-center">
                          <img :src="flag" alt="" width="25" />
                          <span class="ml-2">{{ label }}</span>
                        </div>
                      </template>
                      <template v-slot:option="option">
                        <img :src="option.flag" width="20" height="auto" />
                        {{ option.label }}
                      </template>
                    </v-select>
                    <div
                      class="error invalid-feedback"
                      v-if="
                        ($v.user.phoneCountryIndicator.$model == '' && $v.user.phoneNumber.$dirty && $v.user.phoneNumber.$invalid) ||
                        (!$v.user.phoneNumber.$invalid && $v.user.phoneCountryIndicator.$model == '')
                      "
                    >
                      {{ $t('settings.organization.formOrganization.form.invalid-feedback.field-is-required') }}
                    </div>
                  </CCol>
                  <CCol>
                    <CInput
                      type="text"
                      name="phoneNumber"
                      id="phoneNumber"
                      addInputClasses="pr-2"
                      maxlength="15"
                      :value.sync="$v.user.phoneNumber.$model"
                      @keypress="isNumber($event)"
                      :isValid="checkIfValid('phoneNumber')"
                      :invalidFeedback="$t('auth.newRegister.inputFeedback.required')"
                    />
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCol>

          <CCol md="6">
            <CInput
              class="mb-0"
              :label="$t('auth.newRegister.input.email')"
              type="email"
              id="email"
              maxlength="255"
              addLabelClasses="mt-1 mb-0 required"
              :value.sync="$v.user.email.$model"
              :isValid="checkIfValid('email')"
              :invalidFeedback="$t('auth.newRegister.inputFeedback.required')"
              aria-describedby=""
              :placeholder="$t('auth.newRegister.input.email')"
              :readonly="external"
            />
          </CCol>
          <CCol md="6">
            <CInput
              class="mb-0"
              :label="$t('auth.newRegister.input.confirmEmail')"
              type="email"
              id="confirmEmail"
              maxlength="255"
              addLabelClasses="mt-1 mb-0 required"
              :value.sync="$v.user.confirmEmail.$model"
              :isValid="checkIfValid('confirmEmail')"
              :invalidFeedback="fieldInvalidationReturn($v.user.confirmEmail, 'email')"
              aria-describedby=""
              :placeholder="$t('auth.newRegister.input.confirmEmail')"
              :readonly="external"
            />
          </CCol>
          <CCol md="6" class="mt-2">
            <CForm autocomplete="off">
              <CInput
                v-if="!external"
                class="mb-0"
                autocomplete="off"
                :label="$t('auth.newRegister.input.password')"
                :type="typeInputPassword"
                addLabelClasses="mt-1 mb-0 required"
                :value.sync="$v.user.password.$model"
                :isValid="checkIfValid('password')"
                :invalidFeedback="$t('auth.newRegister.inputFeedback.required')"
                id="password"
                v-focus="focused"
                @focus="focused = true"
                @blur="focused = false"
                placeholder=""
              >
                <template #append>
                  <CButton @click="showPassword('typeInputPassword')">
                    <i class="far" :class="`fa-${iconInputPassword}`"></i>
                  </CButton>
                </template>
              </CInput>
            </CForm>
            <div v-show="focused" class="text-muted checkPassword">
              <p class="text-muted mb-1">{{ $t('auth.newRegister.text.password-requirements') }}</p>
              <ul class="p-0 font-smaller checkPassword__list">
                <li v-for="(item, i) in listCheckPassword" :key="i" class="font-smaller checkPassword__item" :class="{ 'is-valid': item.isValid }">
                  * {{ item.name }}
                </li>
              </ul>
            </div>
          </CCol>
          <CCol md="6" class="mt-2">
            <CForm autocomplete="off">
              <CInput
                v-if="!external"
                class="mb-0"
                autocomplete="off"
                :label="$t('auth.newRegister.input.confirmPassword')"
                :type="typeInputConfirmPassword"
                addLabelClasses="mt-1 mb-0 required"
                :value.sync="$v.user.confirmPassword.$model"
                :isValid="checkIfValid('confirmPassword')"
                :invalidFeedback="fieldInvalidationReturn($v.user.confirmPassword, 'password')"
                id="confirmPassword"
              >
                <template #append>
                  <CButton @click="showPassword('typeInputConfirmPassword')">
                    <i class="far" :class="`fa-${iconInputConfirmPassword}`"></i>
                  </CButton>
                </template>
              </CInput>
            </CForm>
          </CCol>
          <CCol md="6" class="mt-2">
            <CRow>
              <CCol sm="12">
                <label for="number" class="label-custom required mt-1">
                  {{ $t('auth.newRegister.select.business-area') }}
                </label>
              </CCol>
              <CCol sm="12">
                <v-select
                  class="mb-0 select-form"
                  addLabelClasses="mt-1 required"
                  v-model="$v.user.businessAreaId.$model"
                  :isValid="checkIfValid('businessAreaId')"
                  :options="optionsBusinnesArea"
                  :invalidFeedback="$t('auth.newRegister.inputFeedback.required')"
                  id="businessAreaId"
                  :placeholder="$t('auth.newRegister.select.business-area')"
                >
                  <template #selected-option="{ label }">
                    <span class="ml-2" :key="label">{{ label }}</span>
                  </template>
                  <template v-slot:option="option">
                    <span>
                      {{ option.label }}
                    </span>
                  </template>
                </v-select>
              </CCol>
            </CRow>
          </CCol>
          <CCol md="6" class="mt-2">
            <CInput
              class="mb-0"
              :label="$t('auth.newRegister.input.company-name')"
              type="text"
              addLabelClasses="mt-1 mb-0 required"
              :maxlength="30"
              :value.sync="$v.user.companyName.$model"
              :isValid="checkIfValid('companyName')"
              :invalidFeedback="$t('auth.newRegister.inputFeedback.required')"
              id="companyName"
              :placeholder="$t('auth.newRegister.input.company-name')"
            />
          </CCol>
          <CCol sm="12" class="mb-1 mt-4">
            <div class="d-flex align-content-center">
              <CInputCheckbox
                type="checkbox"
                :checked.sync="$v.user.acceptedTerms.$model"
                :isValid="checkIfValid('acceptedTerms')"
                :invalidFeedback="''"
                id="acceptedTerms"
                placeholder=""
                custom
              />
              <p class="text-muted font-smaller m-0">
                {{ $t('auth.newRegister.text.sing-in-accept1') }}
                <CLink class="mx-2 text-primary" :to="{ name: 'terms-and-conditions-login' }">
                  <span class="link">{{ $t('auth.newRegister.link.terms-of-service') }}</span>
                </CLink>
                {{ $t('auth.newRegister.text.sing-in-accept2') }}
                <CLink class="mx-2 text-primary text-" :to="{ name: 'privacy-policy-login' }">
                  <span class="link">{{ $t('auth.newRegister.link.privacy-police') }}</span>
                </CLink>
              </p>
            </div>
            <div class="d-flex align-content-center">
              <CInputCheckbox
                type="checkbox"
                :checked.sync="$v.user.acceptedCommunications.$model"
                :isValid="checkIfValid('acceptedCommunications')"
                :invalidFeedback="''"
                id="acceptedCommunications"
                placeholder=""
                custom
              />
              <p class="text-muted font-smaller m-0">
                {{ $t('auth.newRegister.text.agree-marketing') }}
              </p>
            </div>
          </CCol>
          <CCol sm="12" class="mt-3">
            <Recaptcha @verifyMethod="verifyMethodRecaptcha" @renderMethod="renderMethodRecaptcha"></Recaptcha>
          </CCol>
          <CCol sm="12" md="12" class="mt-2">
            <CButton class="mr-5" @click="() => $router.push({ name: 'Login' })">
              <CIcon name="cilArrowLeft" size="custom-size" :height="25" viewBox="0 0 32 32" />
              {{ $t('auth.newRegister.button.backToLogin') }}
            </CButton>
            <CButton :disabled="disableSubmit" color="primary" type="submit" class="px-5">
              {{ $t('auth.newRegister.button.sign-up') }}
            </CButton>
          </CCol>
        </CRow>
      </CForm>
    </CCol>
  </CRow>
</template>
<script>
//TODO remover para produção
import { CallingCodeMoreFlag } from '@/utils/countriesUtils.js'
import services from '@/services.js'
import { mixin as focusMixin } from 'vue-focus'
import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, email, requiredIf, sameAs } from 'vuelidate/lib/validators'
import SocialLogin from '../components/SocialLogin'
import vSelect from 'vue-select'
import Recaptcha from '@/components/Recaptcha'
import { getLanguageEnumValue } from '@/utils/languageUtils'
import { handleErrorCode } from '@/utils/errorHandling.js'
import { getInvalidFeedback } from '@/utils/vuelidate.js'

export default {
  name: 'Register',
  components: {
    SocialLogin,
    vSelect,
    Recaptcha,
  },
  data() {
    return {
      messages: [],
      isRecaptchaActive: false,
      external: false,
      typeInputPassword: 'password',
      typeInputConfirmPassword: 'password',
      focused: false,
      message: [],
      submitted: false,
      countrySelected: '',
      listCheckPassword: {
        hasLowerCase: { name: this.$t('auth.newRegister.text.lower-case'), isValid: false },
        hasSpecial: { name: this.$t('auth.newRegister.text.especial-character'), isValid: false },
        hasUppercase: {
          name: this.$t('auth.newRegister.text.uppercase-character'),
          isValid: false,
        },
        hasMinNumber: { name: this.$t('auth.newRegister.text.minimal-character'), isValid: false },
        hasNumber: { name: this.$t('auth.newRegister.text.one-number'), isValid: false },
      },
      user: {
        name: '',
        email: '',
        confirmEmail: '',
        phoneCountryIndicator: '',
        phoneNumber: '',
        password: '',
        confirmPassword: '',
        businessAreaId: '',
        companyName: '',
        acceptedTerms: null,
        acceptedCommunications: false,
        signupType: 'internal',
      },
      optionsBusinnes: [],
    }
  },
  mixins: [validationMixin, focusMixin],
  validations: {
    user: {
      name: {
        required,
        maxLength: maxLength(30),
      },
      email: {
        required,
        email,
        maxLength: maxLength(255),
      },
      confirmEmail: {
        sameAs: sameAs('email'),
        required,
        email,
        maxLength: maxLength(255),
      },
      phoneCountryIndicator: {
        required,
        minLength: minLength(1),
      },
      phoneNumber: {
        required,
        maxLength: maxLength(255),
      },
      password: {
        required: requiredIf(function () {
          return !this.external
        }),
        strongPassword(password) {
          // Se for login externo, remove a necessidade de validar a força da senha
          if (this.external) return true

          return (
            /[a-z]/.test(password) && // checks for a-z
            /[A-Z]/.test(password) && // checks for A-Z
            /[0-9]/.test(password) && // checks for 0-9
            /\W|_/.test(password) && // checks for special char
            password.length >= 8
          )
        },
      },
      confirmPassword: {
        required: requiredIf(function () {
          return !this.external
        }),
        sameAs: sameAs('password'),
      },
      businessAreaId: {
        required,
        maxLength: maxLength(255),
      },
      companyName: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(255),
      },
      acceptedTerms: {
        required,
        checked: (value) => value === true,
      },
      acceptedCommunications: {
        required: false,
      },
    },
  },
  mounted() {
    this.getBusiness()

    // Tratamento para cadastro de logins externos
    if (this.$route.name === 'NewRegister-External') {
      this.external = true
      this.user.name = decodeURI(this.$route.params.name)
      this.user.email = decodeURI(this.$route.params.email)
      this.user.confirmEmail = decodeURI(this.$route.params.email)
      this.user.signupType = 'external'
    }

    if (this.$route.query.lang) {
      switch (this.$route.query.lang) {
        case 'en':
          this.$root.$emit('chooseLang', 'en-US')
          break
        case 'pt':
          this.$root.$emit('chooseLang', 'pt-PT')
          break
        default:
          break
      }
    }
  },

  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.user[fieldName]
      if (!field.$dirty) {
        return null
      }
      return !(field.$invalid || null)
    },

    getBusiness() {
      this.message = []
      services
        .businessAreas()
        .then((response) => {
          this.optionsBusinnes = response.data
        })
        .catch((err) => {
          this.message.push(err.response)
        })
    },

    register() {
      if (!this.isValid) {
        return
      }

      this.message = []
      this.messages = []

      const obj = {
        name: this.user.name,
        email: this.user.email,
        phoneCountryIndicator: Number(this.user.phoneCountryIndicator.value),
        phoneNumber: Number(this.user.phoneNumber),
        password: this.user.password,
        companyName: this.user.companyName,
        businessAreaId: Number(this.user.businessAreaId.value),
        acceptedTerms: this.user.acceptedTerms,
        acceptedCommunications: this.user.acceptedCommunications,
        signupType: this.user.signupType,
        language: getLanguageEnumValue(this.$store.getters.getLang),
      }

      if (this.external) {
        delete obj.password
      }

      this.$store
        .dispatch('auth/register', obj)
        .then(() => {
          this.$router.push({ name: 'BusinessProfile' })
          // this.message = {
          //   status: 'success',
          //   message: this.$t('auth.newRegister.message.check-email'),
          // }

          // setTimeout(() => {
          //   this.$router.push({ name: 'BusinessProfile' })
          // }, 1000)
        })
        .catch((error) => {
          const errorCode = error?.data?.errorCode || error?.data?.ErrorCode

          this.message = {
            status: 'danger',
            message: handleErrorCode(errorCode),
          }
        })
    },
    isNumber(evt) {
      evt = evt ? evt : window.event
      var charCode = evt.which ? evt.which : evt.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
        evt.preventDefault()
      } else {
        return true
      }
    },

    //TODO add a um mixin ou component
    showPassword(field) {
      if (this[field] === 'password') {
        this[field] = 'text'
      } else {
        this[field] = 'password'
      }
    },

    verifyMethodRecaptcha(event) {
      this.isRecaptchaActive = event
    },

    renderMethodRecaptcha(event) {
      if (!event) {
        window.location.reload
      }
    },

    fieldInvalidationReturn(field, termForTranslation) {
      if (!field.required) {
        return this.$t('auth.newRegister.inputFeedback.required')
      }

      if (!field.sameAs) {
        return this.$t(`auth.newRegister.inputFeedback.sameAs-${termForTranslation}`)
      }
    },
    assignInvalidFeedback(validationObj) {
      return getInvalidFeedback(validationObj)
    },
  },

  computed: {
    disableSubmit() {
      return this.isValid && this.isRecaptchaActive ? false : true
    },

    status() {
      return this.$store.getters['auth/authStatus']
    },

    isValid() {
      return !this.$v.user.$invalid
    },

    iconInputPassword() {
      return this.typeInputPassword === 'password' ? 'eye-slash' : 'eye'
    },

    iconInputConfirmPassword() {
      return this.typeInputConfirmPassword === 'password' ? 'eye-slash' : 'eye'
    },

    optionsCountries() {
      return CallingCodeMoreFlag(this)
    },

    optionsBusinnesArea() {
      const newArr = this.optionsBusinnes.map((item) => {
        return {
          value: item.value,
          label: this.$t('settings.organization.formOrganization.form.options.businessArea' + item.label),
        }
      })
      return newArr
    },
  },
  watch: {
    'user.password': {
      deep: true,
      handler() {
        this.listCheckPassword.hasLowerCase.isValid = /[a-z]/.test(this.user.password) ? true : null
        this.listCheckPassword.hasUppercase.isValid = /[A-Z]/.test(this.user.password) ? true : null
        this.listCheckPassword.hasNumber.isValid = /[0-9]/.test(this.user.password) ? true : null
        this.listCheckPassword.hasSpecial.isValid = /\W|_/.test(this.user.password) ? true : null
        this.listCheckPassword.hasMinNumber.isValid = this.user.password.length >= 8 ? true : null
      },
    },
  },
}
</script>
<style lang="scss" scoped>
//TODO o componente deve aceitar variaveis de mixins @extend %shadow-sm;
.link {
  text-decoration: underline;
}
</style>
<style lang="scss">
.v-select .vs__dropdown-toggle,
.select-form {
  height: 50px;
}
</style>
